<template>
    <div>
      <div class="row">
        <div class="col-md-12 d-none d-sm-block">
          <div class="float-right mb-1">
            <b-button variant="primary" class="mr-1"  v-on:click="updateSalarySpecifications()" v-if="loginState.isAdministrator" :disabled="!isCurrentDate || updating || downloading" >
              <i class="icon-refresh icons mr-1" v-if="!updating"/>
              <b-spinner v-if="updating" class="mr-1" type="border" small />{{!updating ? 'Uppdatera' : 'Uppdaterar'}}
            </b-button>
            <b-button variant="primary" class="mr-1" v-on:click="downloadSalaryFile()" v-if="loginState.isAdministrator" :disabled="downloading || updating" >
              <i class="icon-cloud-download icons mr-1"/>Lönefil
            </b-button>
            <b-button variant="primary" v-on:click="downloadZipFile()" v-if="loginState.isAdministrator" :disabled="downloading || updating || downloadingZip" >
              <i class="fa fa-file-archive-o mr-1" v-if="!downloadingZip"/><b-spinner v-if="downloadingZip" class="mr-1" type="border" small />{{!downloadingZip ? 'Ladda ner som ZIP' : 'Skapar ZIP'}}
            </b-button>                                       
          </div>
         
        </div>
      </div>
        <PeriodSpecifications :key="periodSpecificationsKey" @onPeriodChanged="onSalaryPeriodDateChanged" v-if="loginState.isAuditor"/>
        <UserSpecifications :key="userSpecificationsKey" v-if="loginState.isEmployee"/>
    </div>
</template>

<script>
async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

import PeriodSpecifications from './components/PeriodSpecifications'
import UserSpecifications from './components/UserSpecifications'
import { salarySpecificationService, userService, employeeService } from "../../shared/services";

export default {
  components: {
    PeriodSpecifications,
    UserSpecifications
  },
  methods: {
    async updateSalarySpecifications() {
      this.updating = true;
      try {
        var users = await userService.get();
        var moment = this.$moment(this.salaryPeriodDate);
        var salarySpecifications = await salarySpecificationService.getByDate(moment.format("YYYY-MM-01"));

        var employees = users.filter(p => p.isEmployee && p.isActive).map(p => p.id);
        var specificationEmployees = salarySpecifications.map(p => p.user.id);
        var usersToCreate = employees.filter(p => !specificationEmployees.includes(p));
        
        await asyncForEach(salarySpecifications.filter(p => !p.isLocked && !p.isAttested).map(p => p.id), async (p) => {
          console.log(`Updating salary specification id ${p}`);
          try {
            await salarySpecificationService.update(p);
          } catch {
            this.ShowToast("Fel", `Ett okänt fel uppstod då lönespecifikationen med id ${p} uppdaterades`, "danger");
          }
        });

        await asyncForEach(usersToCreate, async (p) => {
          console.log(`Creating salary specification for user id ${p}`);
          try {
            await salarySpecificationService.create(p, moment.year(), moment.month() + 1);
          } catch {
            this.ShowToast("Fel", `Ett okänt fel uppstod då lönespecifikationen for användar id ${p} skulle skapas`, "danger");
          }
        });

        this.salarySpecifications = await salarySpecificationService.getByDate(moment.format("YYYY-MM-01"));
        this.periodSpecificationsKey++;
        this.userSpecificationsKey++;
        this.ShowToast("Uppdaterat", "Lönespecifikationerna uppdaterades", "success")

      } catch(p) {
        JSON.stringify(p);
        this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationer för innevarande månad skulle uppdateras", "danger")
      }
      finally {
        this.updating = false;
      }
      
    },
    downloadSalaryFile() {
      this.loading = true;
      this.downloading = true;
      salarySpecificationService.getSalaryFile().then(p => {
        this.loading = false;
        this.downloading = false;
      }).catch(() => {
        this.ShowToast("Fel", "Ett okänt fel uppstod när lönefilen skulle hämtas", "danger");
        this.loading = false;
        this.downloading = false;
      });
    },
    downloadZipFile() {
      this.downloadingZip = true;
      if(!this.salaryPeriodDate) this.salaryPeriodDate = this.$moment();
      salarySpecificationService.getZip(this.$moment(this.salaryPeriodDate).format("YYYY-MM-01")).then(p => {
              this.downloadingZip = false;
            }).catch(() => {
              this.ShowToast("Fel", "Ett okänt fel uppstod när lömespecarna skulle laddas ner som ZIP-fil", "danger");
              this.downloadingZip = false;
            });
    },
    onSalaryPeriodDateChanged(date) {
      this.salaryPeriodDate = date;
    },
  },
  mounted() {
    this.salaryPeriodDate = this.$moment();
  },
  computed: {  
    isCurrentDate() {
      if(!this.salaryPeriodDate) return true;
      var now = this.$moment();
      var moment = this.$moment(this.salaryPeriodDate);
      return moment.year() == now.year() && moment.month() == now.month();
    }
  },
  data() {
    return {
      periodSpecificationsKey: 10000,
      userSpecificationsKey: 0,
      updating: false,
      downloading: false,
      downloadingZip: false,
      salaryPeriodDate: null,
    };  
  }

}
</script>

<style>

</style>
